import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Constant } from '@common/constant';
import { catchError } from 'rxjs/operators';
import { NotificationUtil } from '@shared/util/notification.util';
import { Store } from '@ngxs/store';
import { AuthActions } from '@shared/store/auth/auth.actions';
import { ErrorResponse } from '@data/interface/ErrorResponse';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private store: Store,
              private notificationUtil: NotificationUtil) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: any, caught: Observable<HttpEvent<any>>) => {
          if (error instanceof HttpErrorResponse) {
            const { status } = error;
            const delayError = request.headers.has(Constant.HTTP_DELAY_ERROR)
            if (request.headers.has(Constant.HTTP_IGNORE_ERROR)) {
              return throwError({
                handled: false,
                error: error.error,
                customErrorCode: false
              } as ErrorResponse);
            }

            if (status === 403) {
              this.store.dispatch(AuthActions.Logout);
              this.showMessage('ERROR.FORBIDDEN', {}, delayError);
              return throwError({ handled: true, error: error?.error } as ErrorResponse);
            } else if (status === 401) {
              this.showMessage('ERROR.FORBIDDEN', {}, delayError);
            } else if (status === 404) {
              this.showMessage('ERROR.NOT_FOUND', {}, delayError);
              return throwError({ handled: true, error: error?.error } as ErrorResponse);
            } else if (status === 413 && request.headers.has(Constant.HTTP_FILE_TOO_BIG)) {
              this.showMessage('ERROR.FILE_TOO_BIG', {}, delayError);
              return throwError({ handled: true, error: error?.error } as ErrorResponse);
            } else if ([ 400, 422 ].includes(status) && (error.error?.errorCode || error.error?.errorDescription)) {
              const { errorCode, errorDescription } = error.error;
              const customHandleErrorCodes = request.headers.getAll(Constant.HTTP_CUSTOM_HANDLE_ERROR_CODES) || [];

              if (customHandleErrorCodes.includes(errorCode)) {
                return throwError({
                  handled: false,
                  error: error.error,
                  customErrorCode: true
                } as ErrorResponse);
              }

              if (errorDescription) {
                this.showMessage(errorDescription, { errorCode }, delayError);
              } else {
                this.showMessage('ERROR.GENERAL_ERROR', { errorCode }, delayError);
              }

              return throwError({ handled: true, error: error.error } as ErrorResponse);
            } else {
              this.showMessage('ERROR.GENERAL_ERROR', {}, delayError);
            }
          }

          return throwError({ handled: true, error: error.error } as ErrorResponse);
        }));
  }

  private showMessage(key: string, params: any = {}, delayError = false) {
    if (!delayError) {
      this.notificationUtil.error(key, params);
    } else {
      setTimeout(() => {
        this.notificationUtil.error(key, params);
      }, 1000)
    }

  }
}
